import { render } from "./VabeneRestaurantList.vue?vue&type=template&id=9cbad312&ts=true"
import script from "./VabeneRestaurantList.vue?vue&type=script&lang=ts"
export * from "./VabeneRestaurantList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__